import React from 'react';
import styled from 'styled-components';

type ArrowMarkerProps = {
  id: string;
  size: number;
};

const ArrowMarker = ({ id, size }: ArrowMarkerProps) => {
  const viewBox = `0 ${-size} ${size * 2} ${size * 2}`;
  const dAttr = `M0,${-size + 1}L${size * 2 - 2},0L0,${size - 1}`;
  const marketProps = {
    id: `${id}`,
    viewBox,
    refX: size * 2 - 2,
    refY: 0,
    markerWidth: size,
    markerHeight: size,
    orient: 'auto-start-reverse',
  };
  return (
    <marker {...marketProps}>
      <StyledPath d={dAttr} stroke="context-stroke" strokeWidth="2" />
    </marker>
  );
};

const StyledPath = styled.path`
  fill: none;
  stroke: ${p => p.theme.colors.gray500};
`;

export default ArrowMarker;
